import {get, isEmpty, isFinite, isNumber} from 'lodash';

import {createStorage} from '/util/async-storage';

const DEFAULT_STORAGE_KEY = 'NAVIGATION_STATE';

const {
  getValue: readNavigationState,
  setValue: writeNavigationState,
  clearValue: clearNavigationState,
} = createStorage({key: DEFAULT_STORAGE_KEY});

export const readState = () =>
  readNavigationState().then(stateString => {
    let navigationState = stateString;

    if (isEmpty(navigationState)) {
      navigationState = null;
    }

    return navigationState;
  });

export const writeState = (state: any) => writeNavigationState(state || '');

export const clearState = () => clearNavigationState();

export const getActiveRoutes = (state: any) => {
  let navigationPath = [{name: '<root>', params: undefined}];

  let queryPath: any = [];
  while (true) {
    const routes = get(state, [...queryPath, 'routes'].join('.'));
    const routeIndex = get(state, [...queryPath, 'index'].join('.'));

    if (
      !isEmpty(routes) &&
      isNumber(routeIndex) &&
      isFinite(routeIndex) &&
      routeIndex >= 0
    ) {
      const routeName = get(
        state,
        [...queryPath, 'routes', routeIndex, 'name'].join('.'),
      );

      const routeParams = get(
        state,
        [...queryPath, 'routes', routeIndex, 'params'].join('.'),
      );

      navigationPath = [
        ...navigationPath,
        {name: routeName, params: routeParams},
      ];

      queryPath = [...queryPath, 'routes', routeIndex, 'state'];
    } else {
      break;
    }
  }

  return navigationPath;
};
